export default "__VITE_ASSET__B4M9R_gT__"